import { SchemaModifierBasePlainObject } from './schemaModifierBase.plainObject';
import { ExpressionColumnPlainObject } from './expressionColumn.plainObject';

export class GroupByTransformPlainObject extends SchemaModifierBasePlainObject {
    public groupByColumns: ExpressionColumnPlainObject[] = [];
}
